import { render, staticRenderFns } from "./ModalCaixaPostal.vue?vue&type=template&id=0be6ff26&"
import script from "./ModalCaixaPostal.vue?vue&type=script&lang=js&"
export * from "./ModalCaixaPostal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports